export default "__VITE_ASSET__CVToPuqU__"